export default {
  SEARCH_TRANSACTION_TYPES_REPOSITORY: Symbol.for('SEARCH_TRANSACTION_TYPES_REPOSITORY'),
  TRANSACTION_TYPES_STATE_MANAGER: Symbol.for('TRANSACTION_TYPES_STATE_MANAGER'),
  SEARCH_TRANSACTION_TYPES_QUERY: Symbol.for('SEARCH_TRANSACTION_TYPES_QUERY'),
};
